import { API, retryRequest } from '@/services.js'

export const fonteDeDadosDaApi = {
  async buscarAcompanhamento (filtro) {
    const resposta = await API.acompanhamentoDiarioGeral.save(filtro)
    return resposta.data || resposta.body || {}
  },
  async buscarDetalhesDoFuncionario (funcionarioId) {
    const resposta = await API.employee.get({
      id: funcionarioId,
      active: 'false',
      fired: 'not-fired',
    })

    const funcionarios = resposta.data?.success || resposta.body?.success || []
    return resposta.status === 200 && funcionarios.length > 0
      ? funcionarios[0]
      : {}
  },
  async buscarPontosDoFuncionario (funcionarioId, dia) {
    const resposta = await retryRequest(API.timesheet.save, { load: 'pts' }, {
      employees: [funcionarioId],
      startDate: dia,
      endDate: dia,
    })
    return resposta.body.success.lines[0]?.timelogs
  },
  async buscarJornadaDoFuncionario (funcionarioId, dia) {
    const resposta = await retryRequest(API.timesheet.save, { load: 'djs' }, {
      employees: [funcionarioId],
      startDate: dia,
      endDate: dia,
    })
    const { end, start, stPause, endPause } = resposta.body.success.lines[0].dayJourney.journey
    return {
      entrada: start,
      saida: end,
      inicioIntervalo: stPause,
      fimIntervalo: endPause,
    }
  },
}
